import { useStoreSettingsNotifications } from '@/app/store/pinia/settings/notifications'

import { useStoreSettingsForwarding } from '@/entities/forwarding'

import { isWebNotificationApiAvailable } from '@/shared/composables/browser-api'
import { useLocalization } from '@/shared/composables/localization'
import { useServiceWorker } from '@/shared/composables/service-worker'
import { IUserNotification } from '@/shared/types/os-notification'

const GRANTED = 'granted'

export class ServiceWorkerNotification implements IUserNotification {
  private readonly id: string

  constructor (private title: string, private options: NotificationOptions) {
    this.title = title
    this.options = options
    this.id = options.tag ?? (Math.random()*2**32|0).toString()
  }

  public getId (): string {
    return this.id
  }

  public showNotification (): void {
    const { isHiddenNotifications } = useStoreSettingsNotifications()
    const storeSettingsForwarding = useStoreSettingsForwarding()
    const forward = storeSettingsForwarding.dndForward
    if (isHiddenNotifications && forward?.enabled) return
    if (!isWebNotificationApiAvailable()) {
      return
    }
    try {
      Notification.requestPermission((result: string) => {
        if (result === GRANTED) {
          const { swRegistration } = useServiceWorker()
          swRegistration().then((registration) => {
            registration?.showNotification(this.title, this.options)
          })
        }
      })
    } catch (e) {
      console.warn(e)
      const { t } = useLocalization()
      throw new Error(t('common.unableToUseServiceWorkerNotifications'))
    }
  }

  public close () {
    navigator.serviceWorker.ready.then((registration) => {
      registration.getNotifications({ tag: this.options.tag ?? '' }).then((notifications) => {
        notifications.forEach(notification => notification.close())
      })
    })
  }
}
